import React, {useMemo} from 'react';
import {Container, Typography} from '@mui/material';
import {useUser} from '../util/user.js';
import {useLoaderState} from './Loader.js';

export const PermGuard = props=>{
    let {perms, children} = props;
    let [user, userLoading] = useUser();
    useLoaderState(userLoading);
    let allowed = useMemo(()=>user?.permissions?.includes('admin')||
        perms.some(p=>user?.permissions?.includes(p)), [perms, user]);
    if (userLoading)
        return null;
    if (allowed)
        return children;
    return <Container maxWidth="sm"
        sx={{marginTop: 4, marginBottom: 4, textAlign: 'center'}}>
      <Typography variant="h3">אין לך גישה לצפייה בתוכן</Typography>
    </Container>;
};

export const withPermGuard = (Comp, ...perms)=>props=><PermGuard perms={perms}>
  <Comp {...props}/>
</PermGuard>;
